<template>
  <div />
</template>
<script>
export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    path: {
      type: Array,
    },
    polylineCode: {
      type: String,
    },
    strokeColour: {
      type: String,
      default: '#000000'
    },
    strokeOpacity: {
      type: Number,
      default: 1.0
    },
    strokeWeight: {
      type: Number,
      default: 2.0
    },
    borderWeight: {
      type: Number,
      default: 0
    },
    borderColour: {
      type: String,
      default: '#ffffff'
    }
  },
  data() {
    return {
      mapPolyline: null,
      mapBorderPolyline: null,
      clickListener: null
    }
  },
  watch: {
    polylineCode: function() {
      this.polylineUpdated()
    },
    strokeColour: function() {
      if(this.mapPolyline)
        this.mapPolyline.setOptions({ strokeColor: this.strokeColour })
      else
        this.createObjects()
    },
    borderColour: function() {
      if(this.mapBorderPolyline)
        this.mapBorderPolyline.setOptions({ strokeColor: this.borderColour })
      else
        this.createObjects()
    }
  },
  mounted() {
    this.createObjects()
  },
  beforeDestroy() {
    if(this.clickListener)
      this.clickListener.remove()
    if(this.mapPolyline)
      this.mapPolyline.setMap(null)
    if(this.mapBorderPolyline)
      this.mapBorderPolyline.setMap(null)
  },
  methods: {
    createObjects() {
      var path = this.path
      if(this.polylineCode)
        path = this.google.maps.geometry.encoding.decodePath(this.polylineCode)

      if(!path)
        return

      if(this.borderWeight > 0) {
        this.mapBorderPolyline = new this.google.maps.Polyline({
          path: path,
          map: this.map,
          strokeColor: this.borderColour,
          strokeOpacity: this.strokeOpacity,
          strokeWeight: this.strokeWeight + this.borderWeight,
        })
      }
      
      this.mapPolyline = new this.google.maps.Polyline({
        path: path,
        map: this.map,
        strokeColor: this.strokeColour,
        strokeOpacity: this.strokeOpacity,
        strokeWeight: this.strokeWeight,
      })

      this.clickListener = this.mapPolyline.addListener("click", (evt) => {
        this.$emit('click', evt)
      })
    },
    polylineUpdated() {
      if(!this.mapPolyline) {
        this.createObjects()
        return
      }
      
      let path = this.google.maps.geometry.encoding.decodePath(this.polylineCode)

      if(this.mapBorderPolyline)
        this.mapBorderPolyline.setPath(path)
      if(this.mapPolyline)
        this.mapPolyline.setPath(path)
    }
  }
}
</script>
